import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const QRDetails = () => {
  const location = useLocation();
  //const navigate = useNavigate();
  const bookingDetails = location.state?.bookingDetails;

  if (!bookingDetails) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <p className="text-gray-600">No booking details found.</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex items-center justify-center  px-4 py-6 sm:px-6 lg:px-8 pt-10 sm:pt-16 mt-2">
      <div className="absolute top-24 left-10">
        <Link to="/reservation/options" className="text-gray-800 text-xl">
          <FaArrowLeft />
        </Link>
      </div>
      <div className="bg-white p-6 rounded-lg max-w-lg w-full border border-gray-200 shadow-lg">
        <h2 className="text-xl font-semibold text-center text-gray-800">Booking Details</h2>
        <p className="text-center text-gray-500 text-sm mb-4">Review your booking and proceed.</p>

        <form className="space-y-3">
          {/* First Name and Last Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 ">
            <div>
              <label htmlFor="firstName" className="block text-sm font-medium text-gray-800">
                First Name
              </label>
              <input
                type="text"
                id="firstName"
                disabled={true}
                value={bookingDetails.guest.firstname}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
            <div>
              <label htmlFor="lastName" className="block text-sm font-medium text-gray-800">
                Last Name
              </label>
              <input
                type="text"
                id="lastName"
                disabled={true}
                value={bookingDetails.guest.lastname}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 ">
            <div>
              <label htmlFor="emailid" className="block text-sm font-medium text-gray-800">
                Email
              </label>
              <input
                type="text"
                id="emailid"
                disabled={true}
                value={bookingDetails.guest.emailid}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
            <div>
              <label htmlFor="phonenumber" className="block text-sm font-medium text-gray-800">
                Mobile number
              </label>
              <input
                type="text"
                id="phonenumber"
                disabled={true}
                value={bookingDetails.guest.phonenumber}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
          </div>

          {/* Check-In and Check-Out Dates */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="checkInDate" className="block text-sm font-medium text-gray-800">
                Check-In Date
              </label>
              <input
                type="text"
                id="checkInDate"
                disabled={true}
                value={bookingDetails.checkindate}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
            <div>
              <label htmlFor="checkOutDate" className="block text-sm font-medium text-gray-800">
                Check-Out Date
              </label>
              <input
                type="text"
                id="checkOutDate"
                disabled={true}
                value={bookingDetails.checkoutdate}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="noOfPeople" className="block text-sm font-medium text-gray-800">
                Total Guests
              </label>
              <input
                type="text"
                id="noOfPeople"
                disabled={true}
                value={bookingDetails.numberofguests}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
            <div>
              <label htmlFor="checkOutDate" className="block text-sm font-medium text-gray-800">
                Room Number
              </label>
              <input
                type="text"
                id="roomnumber"
                disabled={true}
                value={bookingDetails.roomnumber}
                className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
                readOnly
              />
            </div>
          </div>

          <div>
            <label htmlFor="stay" className="block text-sm font-medium text-gray-800">
              Total Days to stay
            </label>
            <input
              type="text"
              id="stay"
              disabled={true}
              value={bookingDetails.totaldaysstay}
              className="w-full p-2 border border-gray-300 rounded-md text-sm cursor-not-allowed"
              readOnly
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-end gap-2">
            <Link
              to="/reservation/options/booking/welcome"
              state={{ bookingDetails }}
              className="py-2 px-10 bg-cyan-500 text-white font-semibold rounded-md hover:text-black transition"
            >
              Update
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QRDetails;
